import React from "react";

const ActionCheckbox = ({
  checked,
  onChange,
  label,
  disabled = false,
  className = "",
}) => {
  return (
    <label
      className={[
        "inline-flex items-center",
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      title={label}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        aria-label={label}
        disabled={disabled}
        className="h-4 w-4 rounded border-slate-400 text-[#4f46e5] focus:ring-[#4f46e5]"
      />
    </label>
  );
};

export default ActionCheckbox;
